import { EquipmentRequestProjectProductDetail } from "@app/modules/requests/services/request/requests";

export class RequestDetailsModel {
  code = "";
  executorId = 0;
  initiatorId = 0;
  factEndDate = null;
  equipmentRequestTypeId = 0;
  equipmentRequestTypeName = "Доставка";
  initiatorLogin = "Отсутствует";
  equipmentRequestStatusName = "Отклонена";
  executorLogin = "Отсутствует";
  cityName = "Отсутствует";
  begDate = new Date().toISOString();
  equipmentRequestStatusId = 0;
  projectStoreId = 0;
  id = 0;
  projectStoreExternalCode = "";
  projectStoreAddress = "";
  banner = "";
  projectName = "Отсутствует";
  projectId = 0;
  planEndDate = new Date().toISOString();
  comment = "";
  equipmentRequestProjectProduct: EquipmentRequestProjectProductDetail[];

  constructor(data = {} as Partial<RequestDetailsModel>) {
    Object.assign(this, data);
    if (this.equipmentRequestProjectProduct) {
      this.equipmentRequestProjectProduct = data.equipmentRequestProjectProduct;
    } else {
      this.equipmentRequestProjectProduct = [
        {
          projectProductId: 0,
          photoUrl: null,
          quantity: 0,
          code: "0",
          projectProductName: "Отсутствует",
          visitId: 0,
          taskId: 0,
          visit: {
            visitDate: new Date().toISOString(),
            comment: null,
            photo: [
              {
                id: 1,
                url: "",
                userId: 2,
                userLogin: "Отсутствует",
              },
            ],
            userLogin: "",
          },
        },
      ];
    }
  }
}
